const ONE_MEGABYTE = 1e6;

export const maxSize = 100 * ONE_MEGABYTE;

export default {
  maxSize,
};
